import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';

import { BreakpointService } from '../../service/breakpoint.service';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[ifBreakpoint]'
})
export class IfBreakpointDirective implements OnDestroy {
  private breakpoint: 'desktop' | 'mobile';
  private sub: Subscription;

  @Input()
  set ifBreakpoint(val: 'desktop' | 'mobile') {
    this.breakpoint = val;
    this.updateView();
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private breakpointService: BreakpointService
  ) { }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  private updateView() {
    this.sub = this.breakpointService.isDesktop$.pipe(
      map(isDesktop => (isDesktop && this.breakpoint === 'desktop') || (!isDesktop && this.breakpoint === 'mobile'))
    ).subscribe(showView => {
      if (showView) {
        if (!this.viewContainer.length) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        }
      } else {
        this.viewContainer.clear();
      }
    });
  }
}
